
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import MateriaCard from '../shared/components/MateriaCard.js';
import "../shared/css/index.css"
import { Playground, PropsTable } from 'docz'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"materiacard"}}>{`MateriaCard`}</MDXTag>
<MDXTag name="p" components={components}>{`MateriaCard es el contenedor genérico para cuando quiera desplegarse información de materias.`}</MDXTag>
<Playground __position={0} __code={'() => {\n  const datos = {\n    nombre: \'Análisis y Diseño de Sistemas de Información\',\n    clave: 6926,\n    aula: \'5J-205\',\n    docente: {\n      nombre: \'Guzmán Gerardo Alfonso Sánchez Schmitz\',\n      imagen:\n        \'https://buhos.uson.mx/portalalumnos//obtener/fotoEmpleado?noEmpleado=32985\',\n    },\n  }\n  return <MateriaCard materia={datos} />\n}'} __scope={{props: this ? this.props : props,MateriaCard}}>
  { () => {
    const datos = {
      nombre: 'Análisis y Diseño de Sistemas de Información',
      clave: 6926,
      aula: '5J-205',
      docente: {
        nombre: 'Guzmán Gerardo Alfonso Sánchez Schmitz',
        imagen: 'https://buhos.uson.mx/portalalumnos//obtener/fotoEmpleado?noEmpleado=32985'
      }
    }
    return <MateriaCard materia={datos}/>
  }}
</Playground>
<Playground __position={1} __code={'() => {\n  const datos = {\n    nombre: \'Análisis y Diseño de Sistemas de Información\',\n    clave: 6926,\n  }\n  return <MateriaCard materia={datos} />\n}'} __scope={{props: this ? this.props : props,MateriaCard}}>
  { () => {
    const datos = {
      nombre: 'Análisis y Diseño de Sistemas de Información',
      clave: 6926,
    }
return <MateriaCard materia={datos} />
  } }
</Playground>
<PropsTable of={MateriaCard} />
           </MDXTag>
  }
}
  